import {RouterModule, Routes} from '@angular/router';
import {MainComponent} from './main-component/main.component';
import {LoginComponent} from './Viewer/login.component/login.component';
import {AuthGuard} from './Guards/Auth.guard';
import {AlreadyLoggedGuard} from './Guards/Already-logged.guard';
import {SSOLoginComponent} from './Viewer/sso-login/sso-login.component';
import {PublicTourLoginComponent} from './Viewer/public-tour-login/public-tour-login.component';
import {TourAuthGuard} from './Guards/TourAuth.guard';
import {AppLandingComponent} from './Viewer/app-landing/app-landing.component';
import {EmbeddedAppLandingComponent} from './Viewer/emdedded-intosite/embedded-app-landing/embedded-app-landing.component';
import {NotFoundComponent} from './Viewer/not-found/not-found.component';
import {ApplicationLayoutComponent} from './Viewer/application-layout/application-layout.component';

const appRoutes: Routes = [
  {path: 'login', component: LoginComponent,  canActivate: [AlreadyLoggedGuard]},
  {path: 'intosite', component: EmbeddedAppLandingComponent},
  {path: 'ssologin', component: SSOLoginComponent,  canActivate: [AlreadyLoggedGuard]},  
  {path: 'appLanding', component: AppLandingComponent},
  {path: 'publicTour', component: PublicTourLoginComponent},
  {path: '', component: ApplicationLayoutComponent,
    children: [
      {path: '', component: MainComponent, canActivate: [AuthGuard]},
      {path: 'usermanagement', loadChildren: () => import('./user-management/user.routing').then(m => m.userRoutes), canActivate: [AuthGuard]},
      {path: 'rolemanagement', loadChildren: () => import('./role-management/role.routing').then(m => m.roleRoutes), canActivate: [AuthGuard]},
      {path: 'Tour', loadChildren: () => import('./tour-component/tour.routing').then(m => m.tourRoutes), canActivate: [TourAuthGuard] },

    ]
  },
  {path: '**', pathMatch: 'full', component: NotFoundComponent },
];

export const AppRouting = RouterModule.forRoot(appRoutes, {});
